import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    StyleSheet,
    TouchableOpacity
} from 'react-native';

import {
    JDImage,
    JDText
} from '@jdreact/jdreact-core-lib';

import Tag from './tag';

import { pt, px, mta, isWeb } from '../../common/utils';
import img from '../../common/img';

/**
 * 首页--正在热映列表条目
 */
class CinemaItem extends PureComponent {
    render() {
        const { cinemaInfo } = this.props;

        return (
            <TouchableOpacity
                activeOpacity={ 0.5 }
                style={ st.cinema_item }
                onPress={ () => this.toMovieList(cinemaInfo.cinemaId) }
            >
                <View style={ [st.cinema_name_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_name }>{cinemaInfo.cinemaName}</JDText>
                    {!!cinemaInfo.planPrice &&
                        <JDText style={ st.cinema_price_wrap }>
                            <JDText style={ st.cinema_price }>&yen;{cinemaInfo.planPrice / 100}</JDText>
                            起
                        </JDText>
                    }
                </View>
                <View style={ [st.cinema_address_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_address }>{cinemaInfo.address}</JDText>
                    <JDText style={ st.cinema_km }>{cinemaInfo.cinemaDistanceStr}</JDText>
                </View>

                <Tag cinemaTag={ cinemaInfo.cinemaTag } key={ 1 } />

                {
                    cinemaInfo.activityType >= 0 && !!cinemaInfo.promoPrice && cinemaInfo.govSubsidy !== "true" &&
                    <View style={ st.item }>
                        <View style={ st.v_tip }>
                            <View style={ st.tip }>
                                <JDText style={ st.scale }>惠</JDText>
                            </View>
                            <JDText style={ st.i_text }>{ cinemaInfo.promoDesc }</JDText>
                        </View>
                    </View>
                }

                {
                    cinemaInfo.activityType >= 0 && !!cinemaInfo.promoPrice && cinemaInfo.govSubsidy === "true" &&
                    <View style={ st.governmentSubsidyContainer }>
                        <JDText style={ st.governmentSubsidyDiscounts }>惠</JDText>
                        <JDText style={ st.governmentSubsidyContent }>{cinemaInfo.promoDesc}</JDText>
                        {/* <JDText style={ st.governmentSubsidyContent }>{`政府补贴·活动立减6元`}</JDText> */}
                    </View>
                }

                {/* <View>
                    <JDText style={st.show_time_wrap}>
                        最近场次:
                        <JDText style={st.show_time}>{cinemaInfo.showTime}</JDText>
                    </JDText>
                </View> */}
                {!!cinemaInfo.isFreqCinema && <JDImage style={ [st.cinema_been, isWeb && { top: 0 }] } source={ img.been } />}
            </TouchableOpacity>
        );
    }

    toMovieList(cinemaId) {
        const { cinemaInfo, number } = this.props;

        mta('HomeCinema', 'Home', `${cinemaInfo.isFreqCinema == 1 ? '是' : '否'}_${number}_${cinemaInfo.activityType >= 0 ? '是' : '否'}_${cinemaInfo.planPrice}`);
        // if(is_web) {
        //     location.href = `https://m-movie.jd.com/va/cinema/${cinemaId}?jdreactkey=JDReactMovie&jdreactapp=JDReactMovie&rn_transparentenable=true&rn_routerName=movieList&rn_cinemaId=${cinemaId}`;
        // } else {
        localStorage.removeItem('theMovieId');
        localStorage.removeItem('TheDate');
        this.context.router.toMovieList({ cinemaId });
        // }
    }
}

CinemaItem.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    cinema_item: {
        backgroundColor: '#fff',
        paddingVertical: pt(12),
        borderBottomWidth: px(2),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    cinema_common: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: pt(18),
        paddingLeft: pt(15)
    },
    cinema_name_wrap: {
        height: pt(22),
        marginBottom: pt(4)
    },
    cinema_name: {
        fontSize: pt(16),
        width: pt(270)
    },
    cinema_price_wrap: {
        fontSize: pt(14),
        color: '#898989'
    },
    cinema_price: {
        color: '#E2231A',
        fontSize: pt(16)
    },
    cinema_address_wrap: {
        height: pt(18)
    },
    cinema_address: {
        color: '#898989',
        fontSize: pt(12),
        width: pt(270)
    },
    cinema_km: {
        color: '#898989',
        fontSize: pt(13)
    },
    // show_time_wrap: {
    //     color: '#898989',
    //     fontSize: pt(12),
    //     paddingLeft: pt(12)
    // },
    // show_time: {
    //     fontSize: pt(16)
    // },
    cinema_been: {
        position: 'absolute',
        height: pt(24),
        width: pt(24),
        right: 0
    },
    // 促销
    item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: pt(15),
        alignItems: 'center',
        marginTop: pt(7)
    },
    v_tip: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    tip: {
        height: pt(15),
        width: pt(14),
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(5),
        backgroundColor: '#F56A00'
    },
    scale: {
        fontSize: pt(10),
        color: '#fff'
    },
    i_text: {
        color: 'rgba(0,0,0,.45)',
        fontSize: pt(12)
    },
    governmentSubsidyContainer: {
        borderRadius: pt(2),
        marginTop: pt(10),
        marginLeft: pt(15),
        flexDirection: 'row',
        backgroundColor: '#F0FAF4',
        height: pt(14),
        borderWidth: pt(0.5),
        borderStyle: 'solid',
        borderColor: '#BDDFBF',
        position: 'relative',
        alignSelf: 'flex-start',
        paddingRight: pt(3),
    },
    governmentSubsidyDiscounts: {
        height: pt(14.5),
        width: pt(14.5),
        textAlign: 'center',
        lineHeight: pt(15),
        borderRadius: pt(2),
        backgroundColor: '#0AAD48',
        fontSize: pt(10),
        color: '#FFFFFF',
        position: 'absolute',
        left: -pt(0.5),
        top: -pt(0.5),
        zIndex: 1,
    },
    governmentSubsidyContent: {
        marginLeft: pt(18),
        fontSize: pt(10),
        color: '#0AAD48',
        
    }
});

export default CinemaItem;
